import { render } from "./ImageTag.vue?vue&type=template&id=3979e070&scoped=true"
import script from "./ImageTag.vue?vue&type=script&lang=js"
export * from "./ImageTag.vue?vue&type=script&lang=js"

import "./ImageTag.vue?vue&type=style&index=0&id=3979e070&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3979e070"]])

export default __exports__